import React from 'react';

interface TextAreaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  width?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  value,
  onChange,
  placeholder = '',
  rows = 3,
  maxLength = 500,
  width = '50%',
}) => {
  return (
    <div className="flex flex-col" style={{ width }}>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        maxLength={maxLength}
        placeholder={placeholder}
        className="w-full resize-none rounded-sm border border-black p-2 focus:outline-none focus:ring-1 focus:ring-black"
      />
      <div className="mt-1 text-right text-xs text-gray-500">
        {value.length} / {maxLength}
      </div>
    </div>
  );
};

export default TextArea;
